export default {
  401: '当前操作没有权限',
  403: '当前操作没有权限',
  404: '资源不存在',
  default: '系统未知错误，请反馈给管理员'
}
